'use client';

import { useEffect, useState } from 'react';

import styles from './SocialProofRolling.module.scss';

interface Winner {
  nickName: string;
  point: number;
}

const INTERVAL_MS = 3000;

export const SocialProofRolling = ({ winners }: { winners: Winner[] }) => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState<number | null>(null);

  useEffect(() => {
    if (winners.length <= 1) return;

    const id = setInterval(() => {
      setPrev(current);
      setCurrent((i) => (i + 1) % winners.length);
    }, INTERVAL_MS);

    return () => clearInterval(id);
  }, [winners.length, current]);

  useEffect(() => {
    if (prev === null) return;

    const timer = setTimeout(() => setPrev(null), 400);

    return () => clearTimeout(timer);
  }, [prev]);

  if (!winners.length) return null;

  return (
    <div className={styles.container}>
      {prev !== null && (
        <p
          key={`exit-${prev}`}
          className={`${styles.item} ${styles.itemExit} rounded-pill border border-Gray-black bg-Gray-white px-16 py-8 font-400 text-Gray-black typo-body4`}
        >
          <strong>{winners[prev].nickName}</strong>님이{' '}
          <strong className="text-[#e4302c]">
            {winners[prev].point.toLocaleString()}원
          </strong>
          을 받았습니다
        </p>
      )}
      <p
        key={`enter-${current}`}
        className={`${styles.item} rounded-pill border border-Gray-black bg-Gray-white px-16 py-8 font-400 text-Gray-black typo-body4`}
      >
        <strong>{winners[current].nickName}</strong>님이{' '}
        <strong className="text-[#e4302c]">
          {winners[current].point.toLocaleString()}원
        </strong>
        을 받았습니다
      </p>
    </div>
  );
};
